<template>
    <div>
        <h1>Moo Deng</h1>
        <p>Hacktoberfest 2024 mini project</p>
    </div>
</template>